import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import VerticalDirectorAssignLayer from '../components/VerticalDirectorAssignLayer'

const VerticalDirectorAssignPage = () => {
    return (
        <>
            <MasterLayout>
                <VerticalDirectorAssignLayer />
            </MasterLayout>
        </>
    )
}

export default VerticalDirectorAssignPage
